import * as React from 'react';
import {connect} from 'react-redux';
import {createRouteNodeSelector} from 'redux-router5';
import {parseSaleStatusFilter, saleStatusFilterParams} from '~/apps/pos/shared/services/qsfilter';
import SalesListHeader from '../../components/sales/SalesListHeader';
import {SearchableModelHelper} from "~/lib/forms/select";
import {createStatusHelper} from "~/apps/shared/services/forms";
import {getSaleStatus, getSaleStatuses} from "~/apps/pos/shared/services/helpers";
import {navigate} from "~/router";
import {setSaleCurrentPage} from "~/apps/pos/shared/actions/sales";
import { downloadSaleCSV } from "~/apps/pos/shared/services/sales";
import { Features } from "~/apps/shared/consts";


class SalesHeader extends React.Component<any, any> {
  statusHelper: SearchableModelHelper;

  constructor(props) {
    super(props);

    this.statusHelper = createStatusHelper(this.refresh, getSaleStatus, getSaleStatuses);
  }

  refresh = () => {
    this.forceUpdate();
  };

  onExport = (dtStart, dtEnd) => {
    downloadSaleCSV(dtStart, dtEnd);
  }

  render() {
    const { route: { params }, information, dispatch } = this.props;
    const filter = parseSaleStatusFilter(params);
    const hasFhiFeature = information.entities.features && information.entities.features.includes(Features.FHI);

    return (
      <SalesListHeader
        statusHelper={this.statusHelper}
        filter={filter}
        onStatusChange={(statusKey) => {
          filter.status = statusKey;
          navigate('pos.mobile.history', saleStatusFilterParams(filter));
        }}
        onFilter={(q) => {
          filter.q = q;
          navigate('pos.mobile.history', saleStatusFilterParams(filter));
          dispatch(setSaleCurrentPage(0));
        }}
        onCreate={() => {
          navigate('pos.mobile.createSale');
        }}
        onExport={hasFhiFeature && this.onExport}
      />
    );
  };
}

const mapStateToProps = (state) => {
  const selector = createRouteNodeSelector('pos.mobile.history');

  return {
    information: state.shared.information,
    ...selector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesHeader) as any;
